/* unplugin-vue-components disabled */import __unplugin_components_0 from '~icons/mdi/chevron-right';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-alert",
    { staticClass: "mb-2 pa-0", attrs: { text: "", color: _vm.color } },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _vm.items.length
            ? _c("v-breadcrumbs", {
                attrs: { items: _vm.items, dense: "", divider: "/" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "divider",
                      fn: function () {
                        return [_c(__unplugin_components_0)]
                      },
                      proxy: true,
                    },
                    {
                      key: "item",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-breadcrumbs-item",
                            {
                              attrs: {
                                exact: "",
                                href: item.to,
                                disabled: item.disabled,
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(item.text) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1859393706
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }